//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'DeltaPP',
  data () {
    return {
      defaultJson: {
        'Maximum Systolic BP': '最大收缩压',
        'Likely to respond to fluid challenge': '补液试验倾向于有反应',
        'Maximum Diastolic BP': '最大舒张压',
        'Unlikely to respond to fluid challenge': '补液试验倾向于无反应',
        'Minimum Systolic BP': '最小收缩压',
        '∆ PP': '∆ PP',
        'Minimum Diastolic BP': '最小舒张压'
      },
      form: {
        psysmax: '',
        psysmin: '',
        pdiamax: '',
        pdiamin: ''
      },
      hasScore: false,
      disabled: false,
      dataList1: [
        {value: '0', name: '从不'},
        {value: '10', name: '一周内'},
        {value: '5', name: '曾有'}
      ],
      dataList2: [
        {value: '0', name: '从不'},
        {value: '10', name: '6个月内'},
        {value: '5', name: '超过6个月'}
      ],
      logit: '...'
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad'])
  },
  computed: {
    /** 计算公式结果 */
    score () {
      let self = this
      console.log(self.form)
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            if (form[key] == '---') {
              flag = false
            } else {
              form[key] = Number(form[key])
            }
          }
        }
      }

      if (!flag) {
        self.hasScore = false
        self.logit = '...'
        return '...'
      } else {
        console.log(form)
        var ppmax = form.psysmax - form.pdiamax
        var ppmin = form.psysmin - form.pdiamin
        let result = Math.round(100 * (ppmax - ppmin) / ((ppmax + ppmin) / 2))
        if (result < 13) {
          self.logit = self.defaultJson['Unlikely to respond to fluid challenge']
        } else {
          self.logit = self.defaultJson['Likely to respond to fluid challenge']
        }
        self.hasScore = true
        return String(result)
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/formulas/Anae/DeltaPP.vue